import { withMetadata } from '../metadata'
import { isValidPhoneNumber as _isValidPhoneNumber } from '../../core/index'

export function isValidPhoneNumber() {
	return withMetadata(_isValidPhoneNumber, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/isValidPhoneNumber.js
// module id = 16ve
// module chunks = 0 1